import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './TableRow.scss';
import { Checkbox, DisabledIcon } from '.';

const propTypes = {
  rowAuth: PropTypes.func,
  rowAuthMsg: PropTypes.string,
  enableCheckboxes: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  item: PropTypes.object.isRequired,
  onCheck: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onlyShowAuthenticated: PropTypes.bool,
  toggleAuthenticatedPages: PropTypes.func,
  builderListViewFeature: PropTypes.bool,
  rowStyle: PropTypes.string,
};

const TableRow = ({
  rowAuth,
  enableCheckboxes,
  columns,
  item,
  rowAuthMsg,
  onCheck,
  isChecked,
  onlyShowAuthenticated,
  builderListViewFeature,
  rowStyle,
}) => {
  let row = [<td key="td-cb" />];

  if (enableCheckboxes) {
    row = (!rowAuth || (rowAuth && rowAuth(item))) ?
      [
        <td key="td-cb">
          {builderListViewFeature && <Checkbox
            item={item}
            onCheck={e => onCheck(e, item.id)}
            isChecked={isChecked}
          />}
        </td>,
      ] : [
        <DisabledIcon
          rowAuthMsg={rowAuthMsg}
          key="td-cb-disabled"
        />,
      ];
  }

  let rowDisabledClass = '';
  if (rowAuth && !rowAuth(item)) rowDisabledClass = style.disabledRow;

  row.push(...columns.map(column => (
    <td
      key={`td-${item.id}-${column.title}`}
      className={cx(column.style, !column.hideRowStyle && rowStyle, { [rowDisabledClass]: !column.noAuth })}
    >
      <column.component {...item} {...column.params} />
    </td>
  )));

  if (onlyShowAuthenticated) {
    return (
      <tr key={`tr-${item.id}`}>
        {(rowAuth && rowAuth(item)) ? row : null}
      </tr>
    );
  }
  return (
    <tr key={`tr-${item.id}`}>
      {row}
    </tr>
  );
};

TableRow.propTypes = propTypes;

export default TableRow;
